import { Link } from "react-router-dom";
import { XCircle, RefreshCw } from "lucide-react";
import "../../styles/subscription.css";

export default function PaymentFailedPage() {
  return (
    <div className="sub-page sub-result-page">
      <div className="sub-result-card failed">
        <XCircle size={48} />
        <h1>Payment failed</h1>
        <p>We could not process your payment. No charges were made. You can retry from billing.</p>
        <Link to="/settings/subscription" className="sub-btn sub-btn-primary">
          <RefreshCw size={15} /> Retry payment
        </Link>
        <Link to="/pricing" className="sub-btn sub-btn-ghost">View plans</Link>
      </div>
    </div>
  );
}
